import React, { useState } from 'react';
import useDidUpdateEffect from '@use-effect/did-update';

import { Wrapper, Label, HiddenCheckbox, StyledTick } from './Checkbox.styled';

export interface Props extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'checked'> {
    id: string;
    name: string;
    label: string;
    defaultChecked?: boolean;
    value: string;
    handleCheckedChange?(
        checked: boolean,
        name: string,
        value: string,
        label: string
    ): React.SyntheticEvent | void;
}

const Checkbox: React.FC<Props> = props => {
    const {
        id,
        name,
        label,
        disabled,
        value,
        defaultChecked = false,
        handleCheckedChange,
        className,
        ...rest
    } = props;
    const [checked, setChecked] = useState(defaultChecked);

    useDidUpdateEffect(() => {
        if (handleCheckedChange) {
            handleCheckedChange(checked, name, value, label);
        }
    }, [checked]);

    useDidUpdateEffect(() => {
        if (defaultChecked !== checked) {
            setChecked(defaultChecked);
        }
    }, [defaultChecked]);

    const keyboardPress = (event: React.KeyboardEvent) => {
        if (event.key === 'Space') {
            event.preventDefault();

            setChecked(!checked);
        }
    };

    return (
        <Wrapper className={className}>
            <HiddenCheckbox
                id={id}
                name={name}
                checked={checked}
                aria-checked={checked}
                onChange={() => setChecked(!checked)}
                onKeyDown={e => keyboardPress(e)}
                disabled={disabled}
                type="checkbox"
                value={value}
                {...rest}
            />
            <Label htmlFor={id} $checked={checked} $disabled={disabled ? disabled : false}>
                <StyledTick $checked={checked} />
                {label}
            </Label>
        </Wrapper>
    );
};

export default Checkbox;
